import {
  getImageUrl,
  getVideoUrl,
  transformations,
} from "../util/get-url-utils";
import { useBaseMediaUrls } from "./useBaseMediaUrls";

export const useMediaSrc = (media, type) => {
  const cloudinaryUrl = useBaseMediaUrls(type);
  const mediaUrlsSmall = getMedia(
    media,
    type,
    transformations.small,
    cloudinaryUrl
  );

  const mediaUrlsMedium = getMedia(
    media,
    type,
    transformations.medium,
    cloudinaryUrl
  );

  const mediaUrlsLarge = getMedia(
    media,
    type,
    transformations.large,
    cloudinaryUrl
  );

  return {
    mediaUrlsSmall,
    mediaUrlsMedium,
    mediaUrlsLarge,
  };
};

const getMedia = (media, type, size, cloudinaryUrl) => {
  return media?.map((mediaElement) => {
    return type === "images"
      ? getImageUrl(mediaElement.publicId, cloudinaryUrl, size)
      : getVideoUrl(mediaElement.publicId, cloudinaryUrl, size);
  });
};
